import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=bbcb243c&scoped=true"
import script from "./IconUser.vue?vue&type=script&lang=js"
export * from "./IconUser.vue?vue&type=script&lang=js"
import style0 from "./IconUser.vue?vue&type=style&index=0&id=bbcb243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb243c",
  null
  
)

export default component.exports